<div class="col-lg-12">
    <div class="row  d-flex justify-content-center mt-5">
    <div class="">
        <div class="col-12">
            <div class="container">
                <div class="icon">🚫</div>
                <h1>Access Denied</h1>
                <p>You do not have permission to view this page.</p>
                <a (click)="goHome()" class="button">Go Back Home</a>
              </div>
        </div>
    </div>
</div>
</div>